import { Component, OnInit, Output, EventEmitter, trigger,
  state,
  style,
  animate,
  transition,
  keyframes } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CleanersService } from '../../../../injections/cleaners.service';
import { PATTERNS, getYears } from '../../../../globals';
import * as moment from 'moment';
import { getProvinces, getCities } from "../../../../globals";

@Component({
    selector: 'cleaners-create',
    templateUrl: '../../templates/partials/create-cleaners.html',
    animations: [
    trigger('searchCleaner', [
            state('void', style({
                overflow: 'hidden',
                "max-height": '0'
                
            })),
            state('inactive', style({
                overflow: 'hidden',
                "max-height": '0'
                
            })),
            state('active', style({
                display: 'block',
                "max-height": '1000px',

            })),
            transition('inactive => active', animate('400ms ease-in')),
            transition('active => inactive', animate('400ms ease-out'))
        ]),

    ],
})

export class CreateCleanersComponent implements OnInit {
    public createCleaner: FormGroup;
    public searchActive = "inactive";
    public documentExists = false;
    @Output() submitCleaner = new EventEmitter();
    public years = [];
    public offices: Array<object>;
    public cities: Array<object>;
    constructor(private _fb: FormBuilder, private cleanersService: CleanersService) { 
        getYears(this.years);
        this.offices = getProvinces();
        this.cities = getCities();
    }

    public submitForm(value) {
        //console.log(this.createCleaner);
        var province = JSON.parse(this.createCleaner.value.province);
        var city = JSON.parse(this.createCleaner.value.city);
        
        let object: Object = {
            document: this.createCleaner.value.dni,
            documentExpirationMonth: this.createCleaner.value.month,
            documentExpirationYear: this.createCleaner.value.year,
            documentType: this.createCleaner.value.documentType,
            phone1: this.createCleaner.value.phone,
            phone2: "",
            name: this.createCleaner.value.name,
            surname: this.createCleaner.value.surname,
            address: this.createCleaner.value.street,
            addressType: "street",
            number: this.createCleaner.value.number,
            floor: this.createCleaner.value.floor,
            door: this.createCleaner.value.door,
            zipCode: this.createCleaner.value.postalCode,
            email: this.createCleaner.value.email,
            city: city.name,
            province: province.name,
            clintuOfficeId: province.id,
            iban: this.createCleaner.value.iban,
        }
        //console.log(object);
        object = JSON.stringify(object);
        this.submitCleaner.emit(object);
    }

    public toggleSearch() {
      this.searchActive = (this.searchActive == 'active') ? 'inactive' : 'active';
    }

    public setDNIStatus(status: string) {
        if(status == "NOTOK") {
            this.documentExists = true;
            this.createCleaner.controls['dni'].setErrors({'incorrect': true});
        }else{
            this.documentExists = false;
        }
    }

    public checkValidityDate() {
        if(this.createCleaner.value.year && this.createCleaner.value.month){
            var expiration = this.createCleaner.value.month + "/" + this.createCleaner.value.year;
            var today = moment();
            var e = moment(expiration,"MM/YYYY");
            if(e < today){
                this.createCleaner.controls['month'].setErrors({'incorrect': true});
                this.createCleaner.controls['year'].setErrors({'incorrect': true});
            }else{
                this.createCleaner.controls['month'].setErrors(null);
                this.createCleaner.controls['year'].setErrors(null);
            }
        }
    }

    onValueChanged(data: any) {}

    ngOnInit() {

        this.createCleaner = this._fb.group({
            dni: ['', [Validators.required]],
            name: ['', [Validators.required]],
            surname: ['', [Validators.required]],
            phone: ['', [Validators.required,Validators.pattern(PATTERNS["phone"])]],
            month: ['', [Validators.required]],
            documentType: ['', [Validators.required]],
            year: ['', [Validators.required]],
            street: ['', []],
            number: ['', []],
            floor: ['', []],
            door: ['', []],
            postalCode: ['',[Validators.pattern(PATTERNS["postalCode"])]],
            province: ['', [Validators.required]],
            city: ['', [Validators.required]],
            iban: ['',[Validators.pattern(PATTERNS["iban"])]],
            email: ['',[Validators.required,Validators.pattern(PATTERNS["email"])]]
        });

         this.createCleaner.valueChanges.subscribe(data => {
             this.checkValidityDate();
         });
    }

    
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/dummy/create-cleaners.component.ts